import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles["footer"]}>
      <div className={styles["footer-container"]}>
        <div className={styles["footer-content"]}>
          <p className={styles["footer-text"]}>
            © {new Date().getFullYear()} LifeInPXL. All rights reserved.
          </p>
          <div className={styles["footer-links"]}>
            <a href="/contact" className={styles["footer-link"]}>Contact</a>
            <a href="/privacy" className={styles["footer-link"]}>Privacy</a>
            <a href="/terms" className={styles["footer-link"]}>Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

